import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { CommonService } from './common.service';
import { MessageService } from './message.service';

import { environment } from '../../environments/environment';

@Injectable()
export class AnalysisService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private messageService: MessageService
  ) { }

  private httpOptions = this.commonService.httpOptions;
  private Options  = this.commonService.Options;

  getQuestionList (tqcid:number,lid:number){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/analysis/questionList/' + tqcid + '/' + lid,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('question_list', []))
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/service/analysis.service.ts